import { z } from "zod";

/**
 * A reference to a Roboto file from within a persisted visualization
 * configuration.
 *
 * `fileId` is the only field the app resolves against the backend;
 * `relativePath` is carried for display (so a sidebar can label a
 * reference without a round-trip) and `associationId` names the dataset
 * the file belongs to.
 *
 * Lives in its own module rather than in `v1.ts` because `v1.ts` imports
 * the per-panel schemas, and those panels (`./three-d`) need to reference
 * a file too — importing it back out of `v1.ts` would be a cycle.
 */
export const fileSchema = z.strictObject({
  fileId: z.string(),
  relativePath: z.string().nullable().optional(),
  associationId: z.string().nullable().optional(),
});

export type File = z.infer<typeof fileSchema>;
